import * as angular from "angular";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class TaskAlerts {

  constructor(private bringozToastService: BringozToastService) {
  }


  // UPDATE //
  updateInternalTaskSuccess() {
    const message = {
      body: 'INTERNAL_TASK_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateInternalTaskError() {
    const message = {
      body: 'INTERNAL_TASK_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  //  Service Time
  updateTaskServiceTimeSuccess() {
    const message = {
      body: 'UPDATE_TASK_SERVICE_TIME_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateTaskServiceTimeError() {
    const message = {
      body: 'UPDATE_TASK_SERVICE_TIME_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  //  Extra Info
  updateTaskExtraInfoSuccess() {
    const message = {
      body: 'UPDATE_TASK_EXTRA_INFO_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateTaskExtraInfoError() {
    const message = {
      body: 'UPDATE_TASK_EXTRA_INFO_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  revertTaskStatusSuccess() {
    const message = {
      body: 'REVERT_TASK_STATUS_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  revertTaskStatusError() {
    const message = {
      body: 'REVERT_TASK_STATUS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


}

angular
  .module('bringoz.admin.tasks')
  .service('taskAlerts', TaskAlerts);
